/**
 * What a family's balance means, in words. Balance is credit minus charges:
 * negative is owed (see the billing invariants), positive is a credit.
 *
 * Until 2026-10-11 a $0 balance read "You have credit", because both
 * billing cards treated zero as positive.
 */
export type BalanceStatusKey = "youHaveCredit" | "youOweThisAmount" | "allSettled";

export const BALANCE_STATUS_DEFAULTS: Record<BalanceStatusKey, string> = {
  youHaveCredit: "You have credit",
  youOweThisAmount: "You owe this amount",
  allSettled: "All settled",
};

export function balanceStatusKey(balance: number | string | null | undefined): BalanceStatusKey {
  const cents = Math.round(Number(balance || 0) * 100);
  if (cents > 0) return "youHaveCredit";
  if (cents < 0) return "youOweThisAmount";
  return "allSettled";
}
